import { useMutation } from "@tanstack/react-query";
import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { verifyEmail } from "service";
import { toast } from "sonner";

interface IResponse {
  message: string;
}

export const useVerify = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const encodeToBase64 = (uidb: string | null): string => {
    if (!uidb) {
      throw new Error(
        "Invalid ID: Cannot encode null or undefined value to Base64."
      );
    }
    return btoa(uidb);
  };

  const id = searchParams.get("id");
  const token = searchParams.get("token");

  const { mutate, data, isPending } = useMutation<IResponse>({
    mutationFn: async () => {
      if (!id || !token) {
        throw new Error("Invalid parameters: ID and token are required.");
      }
      const response = await verifyEmail(id, token);
      return response;
    },
    onSuccess: (data) => {
      toast.success(data.message);
      setTimeout(() => {
        navigate("/auth");
      }, 3000);
    },
    onError: (error: any) => {
      console.error("Verification error:", error);
    },
  });

  useEffect(() => {
    if (id && token) {
      mutate();
    } else {
      navigate("/auth");
    }
  }, [id, token, mutate, navigate]);

  return {
    isPending,
    data,
  };
};
